import { render, staticRenderFns } from "./DiseasePacs.vue?vue&type=template&id=51cdc5a8&scoped=true"
import script from "./DiseasePacs.vue?vue&type=script&lang=js"
export * from "./DiseasePacs.vue?vue&type=script&lang=js"
import style0 from "./DiseasePacs.vue?vue&type=style&index=0&id=51cdc5a8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdc5a8",
  null
  
)

export default component.exports